module.exports = __webpack_public_path__ + "static/media/Deer_meat_cooked.16d2b2c6.png";